import { ArrowLeft } from "lucide-react";

export default function LegalNotice() {
  return (
    <div
      data-testid="legal-notice-page"
      className="min-h-screen bg-[#050505] pt-28 pb-24"
    >
      <div className="max-w-3xl mx-auto px-6 lg:px-12">
        {/* Back link */}
        <a
          href="/"
          data-testid="legal-back-link"
          className="inline-flex items-center gap-2 text-gold/60 text-xs uppercase tracking-[0.2em] hover:text-gold transition-colors duration-300 mb-16"
        >
          <ArrowLeft size={14} strokeWidth={1.2} />
          Retour à l'accueil
        </a>

        {/* Header */}
        <div className="mb-16">
          <p className="font-accent italic text-gold text-base tracking-widest mb-4">
            Informations légales
          </p>
          <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight mb-6">
            Mentions Légales
          </h1>
          <div className="gold-line w-16 mb-8" />
          <p className="text-white/40 text-sm leading-[1.9] font-light tracking-wide">
            Conformément aux dispositions des articles 6-III et 19 de la Loi
            n°2004-575 du 21 juin 2004 pour la confiance dans l'économie
            numérique, dite L.C.E.N., il est porté à la connaissance des
            utilisateurs et visiteurs du site les présentes mentions légales.
          </p>
        </div>

        {/* Sections */}
        <div className="flex flex-col gap-14">
          {/* Éditeur */}
          <div data-testid="legal-section-editor" className="relative">
            <div className="absolute -left-4 top-0 w-4 h-4 border-l border-t border-gold/20 hidden lg:block" />
            <h2 className="font-display text-xl text-white mb-5 tracking-tight">
              Éditeur du site
            </h2>
            <div className="flex flex-col gap-2">
              <p className="text-white/50 text-sm font-light tracking-wide">
                <span className="text-white/70">WARNER VTC</span>
              </p>
              <p className="text-white/40 text-sm font-light tracking-wide">
                EI : M. Erwan CALVEZ
              </p>
              <p className="text-white/40 text-sm font-light tracking-wide">
                SIRET : 911 462 893 00015
              </p>
              <p className="text-white/40 text-sm font-light tracking-wide">
                Siège social : 1 ROUTE DU CONQUET, 29290 SAINT-RENAN
              </p>
              <p className="text-white/40 text-sm font-light tracking-wide">
                Email :{" "}
                <a
                  href="mailto:warnervtc@gmail.com"
                  className="text-gold/60 hover:text-gold transition-colors"
                >
                  warnervtc@gmail.com
                </a>
              </p>
            </div>
            <div className="mt-4 pt-4 border-t border-white/[0.04]">
              <p className="text-white/40 text-sm font-light tracking-wide">
                Directeur de publication : M. LE MERRER Owen
              </p>
            </div>
          </div>

          {/* Hébergeur */}
          <div data-testid="legal-section-host" className="relative">
            <div className="absolute -left-4 top-0 w-4 h-4 border-l border-t border-gold/20 hidden lg:block" />
            <h2 className="font-display text-xl text-white mb-5 tracking-tight">
              Hébergeur du site
            </h2>
            <div className="flex flex-col gap-2">
              <p className="text-white/50 text-sm font-light tracking-wide">
                <span className="text-white/70">IONOS SARL</span>
              </p>
              <p className="text-white/40 text-sm font-light tracking-wide">
                7 place de la Gare, BP 70109
              </p>
              <p className="text-white/40 text-sm font-light tracking-wide">
                57201 Sarreguemines Cedex – France
              </p>
              <p className="text-white/40 text-sm font-light tracking-wide">
                Site :{" "}
                <a
                  href="https://www.ionos.fr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gold/60 hover:text-gold transition-colors"
                >
                  www.ionos.fr
                </a>
              </p>
              <p className="text-white/40 text-sm font-light tracking-wide">
                Tél. : 0970808911
              </p>
            </div>
          </div>

          {/* Accès au site */}
          <div data-testid="legal-section-access" className="relative">
            <div className="absolute -left-4 top-0 w-4 h-4 border-l border-t border-gold/20 hidden lg:block" />
            <h2 className="font-display text-xl text-white mb-4 tracking-tight">
              Accès au site
            </h2>
            <p className="text-white/40 text-sm leading-[1.9] font-light tracking-wide">
              Le Site est accessible en tout lieu, 7j/7, 24h/24 sauf cas de
              force majeure, interruption programmée ou non, et pouvant découler
              d'une nécessité de maintenance. En cas de modification,
              interruption ou suspension du Site, l'éditeur ne saurait être tenu
              responsable.
            </p>
          </div>

          {/* Collecte de données */}
          <div data-testid="legal-section-data" className="relative">
            <div className="absolute -left-4 top-0 w-4 h-4 border-l border-t border-gold/20 hidden lg:block" />
            <h2 className="font-display text-xl text-white mb-4 tracking-tight">
              Collecte de données
            </h2>
            <p className="text-white/40 text-sm leading-[1.9] font-light tracking-wide">
              Le Site assure à l'Utilisateur une collecte et un traitement des
              informations personnelles dans le respect de la vie privée,
              conformément à la loi n°78-17 du 6 janvier 1978. L'Utilisateur
              peut exercer ses droits d'accès, de rectification, de suppression
              et d'opposition par e-mail à :{" "}
              <a
                href="mailto:warnervtc@gmail.com"
                className="text-gold/60 hover:text-gold transition-colors"
              >
                warnervtc@gmail.com
              </a>
            </p>
          </div>

          {/* Bloctel */}
          <div data-testid="legal-section-bloctel" className="relative">
            <div className="absolute -left-4 top-0 w-4 h-4 border-l border-t border-gold/20 hidden lg:block" />
            <h2 className="font-display text-xl text-white mb-4 tracking-tight">
              Bloctel
            </h2>
            <p className="text-white/40 text-sm leading-[1.9] font-light tracking-wide">
              Conformément à l'article L.223-2 du Code de la consommation,
              l'Utilisateur peut s'inscrire gratuitement sur la liste
              d'opposition au démarchage téléphonique :{" "}
              <a
                href="https://www.bloctel.gouv.fr"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gold/60 hover:text-gold transition-colors"
              >
                www.bloctel.gouv.fr
              </a>
            </p>
          </div>

          {/* Règlement litiges */}
          <div data-testid="legal-section-disputes" className="relative">
            <div className="absolute -left-4 top-0 w-4 h-4 border-l border-t border-gold/20 hidden lg:block" />
            <h2 className="font-display text-xl text-white mb-4 tracking-tight">
              Règlement en ligne des litiges
            </h2>
            <p className="text-white/40 text-sm leading-[1.9] font-light tracking-wide">
              En application du Règlement (UE) N° 524/2013, la Commission
              européenne met à disposition une plateforme de règlement des
              litiges en ligne :{" "}
              <a
                href="https://ec.europa.eu/consumers/odr"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gold/60 hover:text-gold transition-colors"
              >
                https://ec.europa.eu/consumers/odr
              </a>
            </p>
          </div>

          {/* Propriété intellectuelle */}
          <div data-testid="legal-section-ip" className="relative">
            <div className="absolute -left-4 top-0 w-4 h-4 border-l border-t border-gold/20 hidden lg:block" />
            <h2 className="font-display text-xl text-white mb-4 tracking-tight">
              Droits de propriété intellectuelle
            </h2>
            <p className="text-white/40 text-sm leading-[1.9] font-light tracking-wide">
              Toute utilisation, reproduction, diffusion, commercialisation ou
              modification de tout ou partie du Site, sans autorisation préalable
              écrite de M. Erwan CALVEZ, est interdite et pourra entraîner des
              poursuites judiciaires.
            </p>
          </div>

          {/* Médiation */}
          <div data-testid="legal-section-mediation" className="relative">
            <div className="absolute -left-4 top-0 w-4 h-4 border-l border-t border-gold/20 hidden lg:block" />
            <h2 className="font-display text-xl text-white mb-4 tracking-tight">
              Médiation des litiges
            </h2>
            <p className="text-white/40 text-sm leading-[1.9] font-light tracking-wide">
              Conformément aux articles L.611-1 à L.611-3 et R.612-1 à R.612-2
              du Code de la consommation, tout consommateur peut recourir
              gratuitement à un médiateur de la consommation.
            </p>
          </div>

          {/* Crédit photo */}
          <div data-testid="legal-section-credits" className="relative">
            <div className="absolute -left-4 top-0 w-4 h-4 border-l border-t border-gold/20 hidden lg:block" />
            <h2 className="font-display text-xl text-white mb-4 tracking-tight">
              Crédit photo
            </h2>
            <p className="text-white/40 text-sm leading-[1.9] font-light tracking-wide">
              Les visuels utilisés sur le site sont soit la propriété exclusive
              de WARNER VTC, soit issus de banques d'images libres de droit.
            </p>
          </div>
        </div>

        {/* Footer signature */}
        <div className="mt-20 pt-10 border-t border-white/[0.04]">
          <p className="text-white/20 text-xs tracking-wider leading-relaxed">
            WARNER VTC — Monsieur CALVEZ Erwan — 1 ROUTE DU CONQUET, 29290
            SAINT-RENAN — SIRET : 91146289300015
          </p>
        </div>
      </div>
    </div>
  );
}
